import React from "react";
import myBackground from "../assets/sprout.png";

const About = () => {
  const sections = [
    {
      title: "Customized Software Solution",
      content: "Seamlessly utilizing cloud computing, UI/UX design, and Big Data! Build your system in any scope."
    },
    {
      title: "Flexible, Fast & Responsive",
      content: "We understand how important timely information is for making business decisions. Good organizational design is crucial, but real-time data fuels growth."
    },
    {
      title: "Why Customization?",
      content: "Off-the-shelf software limits your flexibility and budget. A proprietary solution ensures you stand out and maintain a competitive edge."
    },
    {
      title: "What's Next?",
      content: "If you're looking for a custom software solution, you've come to the right place! Reach out to us, and we'll be happy to help."
    }
  ];

  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center flex flex-col items-center justify-center p-5 pt-20"
      style={{ backgroundImage: `url(${myBackground})` }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl text-center md:text-left space-y-6">
        {sections.map((section, index) => (
          <div key={index} className="bg-[#00df9a] bg-opacity-15 p-6 rounded-2xl shadow-lg text-white">
            <h2 className="text-2xl font-bold">{section.title}</h2>
            <p className="text-lg mt-2">{section.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
